import React from 'react';
import { Search } from 'lucide-react';
import CustomSelect from '../shared/CustomSelect';

const statusOptions = [
    { value: 'ALL', label: 'All Status' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'Inactive' },
    { value: 'LOCKED', label: 'Locked' },
    { value: 'SUSPENDED', label: 'Suspended' }
];

const SystemUserFilters = ({
                               searchTerm,
                               onSearchChange,
                               roleFilter,
                               onRoleChange,
                               statusFilter,
                               onStatusChange,
                               roles = []
                           }) => {
    const roleOptions = [
        { value: 'ALL', label: 'All Roles' },
        ...roles.map((r) => ({ value: r.name, label: r.label || r.name })),
    ];

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <div className="flex flex-col lg:flex-row gap-4">
                {/* Search Input */}
                <div className="flex-1">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => onSearchChange(e.target.value)}
                            placeholder="Search by name or email..."
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                </div>

                {/* Role Filter */}
                <div className="w-full lg:w-48">
                    <CustomSelect
                        value={roleFilter}
                        onChange={onRoleChange}
                        options={roleOptions}
                        placeholder="All Roles"
                    />
                </div>

                {/* Status Filter */}
                <div className="w-full lg:w-48">
                    <CustomSelect
                        value={statusFilter}
                        onChange={onStatusChange}
                        options={statusOptions}
                        placeholder="All Status"
                    />
                </div>

                {/* Clear Filters Button */}
                {(searchTerm || roleFilter !== 'ALL' || statusFilter !== 'ALL') && (
                    <button
                        onClick={() => {
                            onSearchChange('');
                            onRoleChange('ALL');
                            onStatusChange('ALL');
                        }}
                        className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition"
                    >
                        Clear Filters
                    </button>
                )}
            </div>
        </div>
    );
};

export default SystemUserFilters;
